var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btnplus",style:('width:'+_vm.width+'; height:'+ _vm.height +';'),on:{"click":_vm.btnclick}},[_c('span',{staticClass:"plusicon"},[_vm._v("+")]),_c('span',[_vm._v("新增")])])
}
var staticRenderFns = []

export { render, staticRenderFns }